/* eslint-disable no-console */
import { analytics } from './analytics';

interface GamificationEvent {
  type: 'gamification';
  name: 'kbar-search-render' | 'note-pin-press';
}

type TrackEvent = GamificationEvent;

export const logger = {
  track: (data: TrackEvent) => {
    if (__DEV__) {
      console.info('track', data);
    }

    const eventName = `${data.type}.${data.name}`;
    analytics.track(eventName, {
      data,
    });
  },
  error: (
    err: unknown,
    data: Record<string, unknown> = {},
    tags: Tags = {},
  ): void => {
    if (__DEV__) {
      console.error(err);
    }

    // Log error with context data and tags for debugging
    console.error('Error occurred:', {
      error: err,
      data,
      tags,
    });
  },
};

type Mixed = number | string | boolean;
type Tags = Record<string, Mixed>;
